<template>
  <div class="min-h-screen bg-white">
    <!-- 헤더 -->
    <AppHeader title="개인정보처리방침" />

    <!-- 콘텐츠 -->
    <div class="max-w-3xl mx-auto px-4 py-8 pb-32">
      <!-- 서비스 정보 -->
      <div class="mb-8">
        <h1 class="text-2xl font-bold text-slate-900 mb-2">개인정보처리방침</h1>
        <p class="text-sm text-slate-500">시행일: 2024년 1월 1일</p>
      </div>

      <!-- 안내문 -->
      <div class="mb-8 p-4 bg-blue-50 rounded-xl">
        <p class="text-sm text-blue-800 leading-relaxed">
          이에스랩스 코퍼레이션(이하 "회사")은 개인정보보호법 등 관련 법령에 따라 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하게 처리할 수 있도록 다음과 같이 개인정보처리방침을 수립·공개합니다.
        </p>
      </div>

      <!-- 약관 내용 -->
      <div class="space-y-8">
        <!-- 제1조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제1조 (개인정보의 처리 목적)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>회사는 다음의 목적을 위하여 개인정보를 처리합니다.</p>
            <div class="mt-3 space-y-3">
              <div class="p-3 bg-slate-50 rounded-lg">
                <p class="font-medium text-slate-800 mb-1">1. 회원 가입 및 관리</p>
                <p class="text-sm">회원제 서비스 제공, 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지</p>
              </div>
              <div class="p-3 bg-slate-50 rounded-lg">
                <p class="font-medium text-slate-800 mb-1">2. 서비스 제공</p>
                <p class="text-sm">분양 정보 제공, 상담사 매칭, 상담 신청 처리, 커뮤니티 서비스 제공</p>
              </div>
              <div class="p-3 bg-slate-50 rounded-lg">
                <p class="font-medium text-slate-800 mb-1">3. 마케팅 및 광고</p>
                <p class="text-sm">이벤트 정보 제공, 서비스 이용 통계, 맞춤형 서비스 제공 (동의 시)</p>
              </div>
              <div class="p-3 bg-slate-50 rounded-lg">
                <p class="font-medium text-slate-800 mb-1">4. 민원처리</p>
                <p class="text-sm">고객 문의 응대, 불만 처리, 분쟁 해결</p>
              </div>
            </div>
          </div>
        </section>

        <!-- 제2조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제2조 (수집하는 개인정보 항목)</h2>
          <div class="text-slate-600 leading-relaxed space-y-3">
            <div class="overflow-x-auto">
              <table class="w-full text-sm border-collapse">
                <thead>
                  <tr class="bg-slate-100">
                    <th class="border border-slate-200 px-3 py-2 text-left font-medium">구분</th>
                    <th class="border border-slate-200 px-3 py-2 text-left font-medium">수집 항목</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="border border-slate-200 px-3 py-2 font-medium">필수</td>
                    <td class="border border-slate-200 px-3 py-2">이메일, 비밀번호, 이름</td>
                  </tr>
                  <tr>
                    <td class="border border-slate-200 px-3 py-2 font-medium">소셜 로그인</td>
                    <td class="border border-slate-200 px-3 py-2">소셜 계정 정보(이메일, 프로필사진)</td>
                  </tr>
                  <tr>
                    <td class="border border-slate-200 px-3 py-2 font-medium">상담 신청</td>
                    <td class="border border-slate-200 px-3 py-2">이름, 연락처</td>
                  </tr>
                  <tr>
                    <td class="border border-slate-200 px-3 py-2 font-medium">파트너 등록</td>
                    <td class="border border-slate-200 px-3 py-2">이름, 연락처, 소속회사, 명함 이미지</td>
                  </tr>
                  <tr>
                    <td class="border border-slate-200 px-3 py-2 font-medium">자동 수집</td>
                    <td class="border border-slate-200 px-3 py-2">접속 IP, 쿠키, 서비스 이용기록, 접속로그</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <!-- 제3조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제3조 (개인정보의 처리 및 보유 기간)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>① 회사는 법령에 따른 개인정보 보유·이용기간 또는 동의를 받을 때의 보유·이용기간 내에서 개인정보를 처리·보유합니다.</p>
            <div class="mt-3 space-y-2">
              <div class="flex items-start gap-3 p-3 bg-slate-50 rounded-lg">
                <span class="shrink-0 w-24 font-medium text-slate-800">회원 정보</span>
                <span class="text-sm">회원 탈퇴 시까지 (탈퇴 후 30일 내 파기)</span>
              </div>
              <div class="flex items-start gap-3 p-3 bg-slate-50 rounded-lg">
                <span class="shrink-0 w-24 font-medium text-slate-800">상담 신청</span>
                <span class="text-sm">상담 완료 후 1년</span>
              </div>
              <div class="flex items-start gap-3 p-3 bg-slate-50 rounded-lg">
                <span class="shrink-0 w-24 font-medium text-slate-800">서비스 이용기록</span>
                <span class="text-sm">3년 (통신비밀보호법)</span>
              </div>
              <div class="flex items-start gap-3 p-3 bg-slate-50 rounded-lg">
                <span class="shrink-0 w-24 font-medium text-slate-800">결제 기록</span>
                <span class="text-sm">5년 (전자상거래법)</span>
              </div>
            </div>
          </div>
        </section>

        <!-- 제4조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제4조 (개인정보의 제3자 제공)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>① 회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.</p>
            <ul class="list-disc list-inside space-y-1 ml-2 mt-2">
              <li>이용자가 사전에 동의한 경우</li>
              <li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
            </ul>
            <div class="mt-4 p-4 bg-amber-50 rounded-lg border border-amber-200">
              <p class="font-medium text-amber-800 mb-2">상담 신청 시 제3자 제공</p>
              <p class="text-sm text-amber-700">상담 신청 시 고객님의 연락처는 선택하신 상담사(파트너)에게 제공됩니다. 이는 상담 서비스 제공을 위해 필수적이며, 상담 신청 시 동의를 받습니다.</p>
            </div>
          </div>
        </section>

        <!-- 제5조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제5조 (개인정보처리의 위탁)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>① 회사는 원활한 서비스 제공을 위해 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
            <div class="mt-3 overflow-x-auto">
              <table class="w-full text-sm border-collapse">
                <thead>
                  <tr class="bg-slate-100">
                    <th class="border border-slate-200 px-3 py-2 text-left font-medium">수탁업체</th>
                    <th class="border border-slate-200 px-3 py-2 text-left font-medium">위탁업무</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="border border-slate-200 px-3 py-2">Google Firebase</td>
                    <td class="border border-slate-200 px-3 py-2">클라우드 서버 운영, 데이터 저장</td>
                  </tr>
                  <tr>
                    <td class="border border-slate-200 px-3 py-2">Google Analytics</td>
                    <td class="border border-slate-200 px-3 py-2">서비스 이용 통계 분석</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="mt-2">② 회사는 위탁계약 체결 시 관련 법령에 따라 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.</p>
          </div>
        </section>

        <!-- 제6조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제6조 (정보주체의 권리·의무 및 행사방법)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다.</p>
            <ul class="list-disc list-inside space-y-1 ml-2 mt-2">
              <li>개인정보 열람 요구</li>
              <li>오류 등이 있을 경우 정정 요구</li>
              <li>삭제 요구</li>
              <li>처리정지 요구</li>
            </ul>
            <p class="mt-3">권리 행사는 서비스 내 설정 메뉴 또는 고객센터(1533-9012)를 통해 가능합니다.</p>
          </div>
        </section>

        <!-- 제7조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제7조 (개인정보의 파기)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</p>
            <p>② 파기 방법은 다음과 같습니다.</p>
            <ul class="list-disc list-inside space-y-1 ml-2 mt-2">
              <li>전자적 파일: 복구 불가능한 방법으로 영구 삭제</li>
              <li>종이 문서: 분쇄기로 분쇄하거나 소각</li>
            </ul>
          </div>
        </section>

        <!-- 제8조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제8조 (개인정보의 안전성 확보 조치)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
            <ul class="list-disc list-inside space-y-1 ml-2 mt-2">
              <li>개인정보 취급 직원의 최소화 및 교육</li>
              <li>개인정보에 대한 접근 제한</li>
              <li>개인정보의 암호화</li>
              <li>해킹 등에 대비한 기술적 대책</li>
              <li>접속기록의 보관 및 위변조 방지</li>
            </ul>
          </div>
        </section>

        <!-- 제9조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제9조 (쿠키의 사용)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>① 회사는 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 쿠키(cookie)를 사용합니다.</p>
            <p>② 쿠키는 웹사이트가 이용자의 브라우저에 보내는 소량의 정보이며, 이용자의 컴퓨터에 저장됩니다.</p>
            <p>③ 이용자는 쿠키 설치에 대한 선택권을 가지고 있으며, 브라우저 설정을 통해 쿠키를 허용하거나 거부할 수 있습니다.</p>
            <p>④ 쿠키를 거부할 경우 로그인이 필요한 일부 서비스 이용에 제한이 있을 수 있습니다.</p>
          </div>
        </section>

        <!-- 제10조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제10조 (개인정보 보호책임자)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
            <div class="mt-3 p-4 bg-slate-50 rounded-xl">
              <p class="font-bold text-slate-900 mb-2">개인정보 보호책임자</p>
              <div class="text-sm space-y-1">
                <p><span class="text-slate-500">성명:</span> 심응선</p>
                <p><span class="text-slate-500">직책:</span> 대표</p>
                <p><span class="text-slate-500">연락처:</span> 1533-9012</p>
                <p><span class="text-slate-500">이메일:</span> eslabsofficial@gmail.com</p>
              </div>
            </div>
          </div>
        </section>

        <!-- 제11조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제11조 (권익침해 구제방법)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>개인정보침해로 인한 구제를 받기 위해 다음 기관에 분쟁해결이나 상담 등을 신청할 수 있습니다.</p>
            <div class="mt-3 space-y-2 text-sm">
              <div class="p-3 bg-slate-50 rounded-lg">
                <p class="font-medium text-slate-800">개인정보분쟁조정위원회</p>
                <p class="text-slate-500">www.kopico.go.kr / 1833-6972</p>
              </div>
              <div class="p-3 bg-slate-50 rounded-lg">
                <p class="font-medium text-slate-800">개인정보침해신고센터</p>
                <p class="text-slate-500">privacy.kisa.or.kr / 118</p>
              </div>
              <div class="p-3 bg-slate-50 rounded-lg">
                <p class="font-medium text-slate-800">대검찰청 사이버수사과</p>
                <p class="text-slate-500">www.spo.go.kr / 1301</p>
              </div>
              <div class="p-3 bg-slate-50 rounded-lg">
                <p class="font-medium text-slate-800">경찰청 사이버안전국</p>
                <p class="text-slate-500">cyberbureau.police.go.kr / 182</p>
              </div>
            </div>
          </div>
        </section>

        <!-- 제12조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제12조 (개인정보처리방침 변경)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>① 이 개인정보처리방침은 2024년 1월 1일부터 적용됩니다.</p>
            <p>② 이전의 개인정보처리방침은 아래에서 확인할 수 있습니다.</p>
            <p class="text-sm text-slate-400 mt-2">- 이전 버전 없음 (최초 시행)</p>
          </div>
        </section>

        <!-- 회사 정보 -->
        <section class="mt-12 p-6 bg-slate-50 rounded-2xl">
          <h3 class="font-bold text-slate-900 mb-3">이에스랩스 코퍼레이션</h3>
          <div class="text-sm text-slate-600 space-y-1">
            <p>대표: 심응선</p>
            <p>사업자등록번호: 227-31-01670</p>
            <p>주소: 충청북도 청주시 서원구 충대로1, S1-3동 2층 201호 충북대학교 충북Pro메이커센터</p>
            <p>이메일: eslabsofficial@gmail.com</p>
            <p>고객센터: 1533-9012</p>
          </div>
        </section>
      </div>
    </div>

    <!-- 푸터 -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'

export default {
  name: 'PrivacyView',
  components: {
    AppHeader,
    AppFooter
  }
}
</script>
